import React from "react";

const HeadCircumferenceBody = () => {
  return (
    <div>
      <h2>Head Circumference Body Content</h2>
    </div>
  );
};

export default HeadCircumferenceBody;
